export * from './dossiers-search-result.component';
